"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = __importStar(require("react"));

const styled_components_1 = __importDefault(require("styled-components"));

const uuid_1 = require("uuid");
/**
 * This custom checkbox makes use of a hidden native HTML input element to
 * support accessibility features. The custom checkbox is a label of the native
 * input, and will therefore pass through HTML events.
 *
 * @example When you style pseudo-selectors, make sure to apply these selectors
 * to the native input element, and use the adajacent and self selectors to
 * apply the style to the custom checkbox:
 *
 *   ```css
 *   input:disabled + & {
 *     opacity: 0.5;
 *   }
 *   ```
 *
 * @see https://medium.com/claritydesignsystem/pure-css-accessible-checkboxes-and-radios-buttons-54063e759bb3
 */


const CheckboxInput = _a => {
  var {
    id,
    className,
    style,
    checkmark = '✔',
    error
  } = _a,
      props = __rest(_a, ["id", "className", "style", "checkmark", "error"]);

  const idRef = react_1.useRef(id !== null && id !== void 0 ? id : uuid_1.v4());
  return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(NativeCheckbox, Object.assign({
    id: idRef.current
  }, props)), react_1.default.createElement(Checkbox, {
    className: className,
    style: style,
    disabled: props.disabled,
    checked: props.checked,
    error: error,
    htmlFor: idRef.current
  }, props.checked && checkmark));
};

exports.default = CheckboxInput;
const NativeCheckbox = styled_components_1.default.input.attrs({
  type: 'checkbox'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  left: -9999px;\n  opacity: 0;\n"])));
const Checkbox = styled_components_1.default.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid black;\n  font-size: 0.8rem;\n  width: 1rem;\n  height: 1rem;\n  text-align: center;\n  flex-shrink: 0;\n  user-select: none;\n  outline: 5px auto transparent;\n\n  :hover {\n    cursor: pointer;\n  }\n\n  input:disabled + & {\n    pointer-events: none;\n  }\n\n  input:focus + & {\n    outline-color: rgb(59, 153, 252);\n  }\n"])));